import { useState } from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../hooks/useAuth';

function LoginPage({ onSwitchToSignup }) {
  const { login, loginWithGoogleCredential } = useAuth();
  const { t } = useTranslation('auth');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setIsSubmitting(true);
    const result = await login(email.trim(), password);
    setIsSubmitting(false);
    if (!result.success) {
      setError(result.error || t('login.invalidCredentials'));
    }
  };

  const handleGoogleSuccess = async (credentialResponse) => {
    setError('');
    const result = await loginWithGoogleCredential(credentialResponse.credential);
    if (!result.success) {
      setError(result.error || t('login.googleFailed'));
    }
  };

  return (
    <div className="login-page">
      <form onSubmit={handleSubmit} className="card login-card">
        <h1 className="login-title">Zlux</h1>
        <p className="login-subtitle">{t('login.subtitle')}</p>
        <label>
          {t('login.email')}
          <input autoFocus type="email" value={email} onChange={(event) => setEmail(event.target.value)} />
        </label>
        <label>
          {t('login.password')}
          <input type="password" value={password} onChange={(event) => setPassword(event.target.value)} />
        </label>
        {error && <span className="error-text">{error}</span>}
        <button className="primary-btn standout-btn" type="submit" disabled={isSubmitting}>{isSubmitting ? t('login.submitting') : t('login.submit')}</button>

        <div className="login-divider"><span>{t('login.or')}</span></div>

        <div className="google-btn-wrap">
          <GoogleLogin onSuccess={handleGoogleSuccess} onError={() => setError(t('login.googleFailed'))} theme="outline" shape="pill" />
        </div>

        <button type="button" className="text-btn auth-switch-btn" onClick={onSwitchToSignup}>{t('login.switchPrompt')}</button>

        {process.env.NODE_ENV !== 'production' && (
          <p className="login-hint">{t('login.defaultAccountsHint')}</p>
        )}
      </form>
    </div>
  );
}

export default LoginPage;
